import { useState } from 'react';
import { Box, Button, Form, Textarea } from '@bigcommerce/big-design';

export function Notes({ onAddNote }) {
	const [newNote, setNewNote] = useState('');
	const handleFormSubmit = (event) => {
		event.preventDefault();
		event.stopPropagation();

		setNewNote((noteToAdd) => {
			onAddNote(noteToAdd);

			return '';
		});
	};

	return (
		<Box marginLeft="medium" marginBottom="xxxLarge">
			<Form onSubmit={handleFormSubmit}>
				<Textarea
					id="orderNotesAdd"
					label="New Note"
					placeholder="Note for this order"
					required
					value={newNote}
					onChange={(event) => setNewNote(event.currentTarget.value)}
				/>
				<Box marginTop="large">
					<Button actionType="normal" variant="primary">
						Add Note
					</Button>
				</Box>
			</Form>
		</Box>
	);
}
